import { css } from '@/styled-system/css';

export const accordionRootStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  gap: '400',
  listStyle: 'none',
  padding: 'none',
  margin: 'none',
});

export const accordionItemStyles = css.raw({
  listStyle: 'none',
  borderWidth: '0',
  borderRadius: 'none',
});

export const cardPanelStyles = css.raw({
  paddingInline: 'none',
  paddingBlockStart: 'none',
  paddingBlockEnd: 'none',
  borderTopWidth: '0',
  borderBottomLeftRadius: 'none',
  borderBottomRightRadius: 'none',
  backgroundColor: 'transparent',
});

// Positioning context for a control rendered as a sibling of the header trigger.
export const cardHeaderRowStyles = css.raw({
  position: 'relative',
});

// The positioned row paints above the card's block anchor, so clicks pass through it to the link.
export const linkedHeaderRowStyles = css.raw({
  position: 'relative',
  pointerEvents: 'none',
});

export const trailingControlStyles = css.raw({
  pointerEvents: 'auto',
});

// Mirror Accordion.Header's layout (chevron, gap, content) for a card that links instead of expanding.
export const linkedHeaderStyles = css.raw({
  display: 'flex',
  alignItems: 'center',
  gap: 'default',
});

export const linkedHeaderContentStyles = css.raw({
  display: 'flex',
  alignItems: 'center',
  flex: 1,
});

export const spacerIconStyles = css.raw({
  visibility: 'hidden',
  flexShrink: 0,
});

// Must use the same longhands Accordion.Header sets; a `padding` shorthand won't reliably
// override them in Panda's atomic cascade.
export const accordionHeaderStyles = css.raw({
  paddingBlock: '400',
  paddingInline: '400',
});

// Variant for a header that shares its row with a sibling control (e.g. an overflow menu),
// reserving room at the end so the header content doesn't run underneath it.
export const accordionHeaderWithTrailingControlStyles = css.raw({
  paddingBlock: '400',
  paddingInlineStart: '400',
  paddingInlineEnd: '1600',
  // Accordion.Header's child needs to be shrinkable for the header content to truncate.
  '& > [data-c11n-component=Box]': {
    minWidth: 0,
  },
});
